(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.DrvDiscountGiftLogic = api;
})(typeof window === 'undefined' ? globalThis : window, function () {
  const id = value => String(value);
  const integer = value => Number.isSafeInteger(value) && value >= 0;
  const fail = code => { const error = new Error(code); error.code = code; throw error; };
  function isManaged(line) {
    return line.properties?._drv_discount_gift === '1' && line.properties?._drv_discount_gift_product === id(line.product_id);
  }
  function validateRule(rule) {
    if (!rule?.productId || !Array.isArray(rule.gifts) || !integer(rule.selectedCount) || rule.gifts.length !== rule.selectedCount) fail('configuration');
    if (!rule.selectedCount) return rule;
    if (rule.bicycle !== true || rule.configured !== true || rule.selectedCount !== 1 || ![1,2].includes(rule.bikeUnits)) fail('configuration');
    const gift = rule.gifts[0];
    if (!gift.productId || !gift.variantId || id(gift.productId) === id(rule.productId) || !integer(gift.unitPrice) || gift.unitPrice === 0 || gift.variantCount !== 1) fail('configuration');
    return rule;
  }
  function allowances(state) {
    if (!Array.isArray(state.items) || !Array.isArray(state.rules)) fail('configuration');
    const counts = new Map(), desired = new Map(), gifts = new Map(), seen = new Set();
    for (const line of state.items) {
      if (!integer(line.quantity)) fail('quantity');
      if (isManaged(line)) continue;
      const value = (counts.get(id(line.product_id)) || 0) + line.quantity;
      if (!integer(value)) fail('quantity');
      counts.set(id(line.product_id), value);
    }
    for (const rule of state.rules) {
      if (seen.has(id(rule.productId))) fail('configuration');
      seen.add(id(rule.productId));
      const count = counts.get(id(rule.productId)) || 0;
      if (!count) continue;
      validateRule(rule);
      if (!rule.selectedCount) continue;
      const gift = rule.gifts[0], key = id(gift.variantId), previous = gifts.get(key);
      if (previous && (id(previous.productId) !== id(gift.productId) || previous.unitPrice !== gift.unitPrice)) fail('configuration');
      const value = (desired.get(key) || 0) + count * rule.bikeUnits;
      if (!integer(value)) fail('quantity');
      desired.set(key, value);
      gifts.set(key, gift);
    }
    return {desired, gifts};
  }
  function targets(state) {
    const {desired, gifts} = allowances(state);
    for (const [variant, quantity] of desired) {
      const waived = state.giftWaivers?.[variant];
      desired.set(variant, Math.max(0, quantity - (integer(waived) ? waived : 0)));
    }
    return {desired, gifts};
  }
  function plan(state) {
    const {desired, gifts} = targets(state), updates = {}, adds = [];
    const ordinary = new Map();
    for (const line of state.items) {
      const variant = id(line.variant_id), gift = gifts.get(variant);
      if (gift && id(line.product_id) === id(gift.productId)) {
        if (!isManaged(line)) ordinary.set(variant, (ordinary.get(variant) || 0) + line.quantity);
      }
    }
    const remaining = new Map(Array.from(desired, ([variant, quantity]) => [variant, Math.max(0, quantity - (ordinary.get(variant) || 0))]));
    for (const line of state.items) {
      if (!isManaged(line)) continue;
      const variant = id(line.variant_id), gift = gifts.get(variant);
      // Shopify can split identical gift lines by discount allocation. Keep
      // their quantities when the total is right instead of merging them again.
      const quantity = !gift || id(line.product_id) !== id(gift.productId) ? 0 : Math.min(line.quantity, remaining.get(variant) || 0);
      remaining.set(variant, Math.max(0, (remaining.get(variant) || 0) - quantity));
      if (quantity !== line.quantity) updates[line.key] = quantity;
    }
    for (const [variant, quantity] of remaining) {
      if (!quantity) continue;
      const gift = gifts.get(variant);
      if (gift.available !== true) fail('unavailable');
      adds.push({id:variant, quantity, properties:{_drv_discount_gift:'1', _drv_discount_gift_product:id(gift.productId)}});
    }
    return {updates, adds};
  }
  function assertFree(state) {
    const {desired, gifts} = targets(state), covered = new Map();
    for (const line of state.items) {
      const variant = id(line.variant_id), gift = gifts.get(variant);
      if (isManaged(line) && line.quantity && (!gift || line.original_price !== gift.unitPrice || line.final_line_price !== 0 || line.selling_plan_allocation)) fail('discount');
      if (gift && id(line.product_id) === id(gift.productId)) {
        if (!integer(line.original_price) || !integer(line.final_line_price) || line.original_price === 0) fail('discount');
        const freeUnits = Math.min(line.quantity, Math.floor((line.original_price * line.quantity - line.final_line_price) / line.original_price));
        covered.set(variant, (covered.get(variant) || 0) + freeUnits);
      }
    }
    for (const [variant, quantity] of desired) if ((covered.get(variant) || 0) < quantity) fail('discount');
  }
  function clampWaivers(state) {
    const {desired} = allowances(state);
    return Object.fromEntries(Object.entries(state.giftWaivers || {}).filter(([,quantity])=>integer(quantity) && quantity > 0).map(([variant,quantity])=>[variant, Math.min(quantity,desired.get(variant) || 0)]).filter(([,quantity])=>quantity > 0));
  }
  return {validateRule, isManaged, allowances, plan, assertFree, clampWaivers};
});
